<template>
  <div class="py-12">
    <div class="sm:px-6 lg:px-8">
      <DateFilter @dateFilter="handleDateFilter" />
      <!-- Metrics -->
      <div class="grid grid-cols-1 gap-4 mb-8 md:grid-cols-2 lg:grid-cols-3">
        <div
          v-for="(value, key) in metrics"
          :key="key"
          class="overflow-hidden p-6 bg-white shadow-sm dark:bg-gray-800 sm:rounded-lg"
        >
          <h3 class="text-lg font-semibold text-gray-900 capitalize dark:text-gray-100">
            {{ key.replace('_', ' ') }}
          </h3>
          <p class="text-2xl font-bold text-indigo-600 dark:text-indigo-400">
            {{ formatMetric(value, key) }}
          </p>
        </div>
      </div>

      <!-- Recent Orders -->

      <RecentOrdersTable :orders="recentOrders" :pagination="ordersPagination" @pageChange="(page) => adminStore.fetchOrders(page)" />

      <!-- Recent Payments -->
      <RecentPaymentsTable :payments="recentPayments" :pagination="paymentsPagination" @pageChange="(page) => adminStore.fetchPayments(page)" />
    </div>
  </div>
</template>

<script setup>
import { format } from 'date-fns'
import RecentPaymentsTable from '@/components/admin/RecentPaymentsTable.vue'
import RecentOrdersTable from '@/components/admin/RecentOrdersTable.vue'
import { useAdminStore } from '@/stores/adminStore'
import { storeToRefs } from 'pinia'
import { ref, watch, onMounted } from 'vue'
import DateFilter from '@/components/general/DateFilter.vue'
const adminStore = useAdminStore()
const { metrics, recentOrders, recentPayments, ordersPagination, paymentsPagination, loading, error } = storeToRefs(adminStore)

onMounted(() => {
  adminStore.initialize()
})

const formatMetric = (value, key) => {
  // const moneyData = ['amount', 'payments', 'fee']
  if (key.includes('amount') || key.includes('payments') || key.includes('fee') || key.includes('refunds')) {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
    }).format(value)
  }
  return value
}

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
  }).format(amount)
}

const handleDateFilter = (dateFilter, startDate, endDate) => {
  adminStore.fetchDashboardData(dateFilter, startDate, endDate)
}
</script>
